import '../base/list.css';
import { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Tooltip from '@mui/material/Tooltip';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import SingleValue from '../base/single-value';
import filter from '../../../service/filter';
import CONSTANT from '../../../Constant/Constant';
import { Button, IconButton, Stack } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create'
import EditOffIcon from '@mui/icons-material/EditOff';
import ReplayIcon from '@mui/icons-material/Replay';
import IdentifierList from '../../../config/ProfileDetailsData.json'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0)
    },
    nested: {
        paddingLeft: theme.spacing(1),
    },
}));

const ListView = (props) => {
    const classes = useStyles();
    const [nonEditableIdnetifier] = useState(IdentifierList)
    const [open, setOpen] = useState(false);
    const [label, setLabel] = useState(props.label);
    const [value, setValue] = useState(props.value);
    const [updatedValue, setUpdatedValue] = useState(props.value);
    const [updatedValueFlag, setUpdatedValueFlag] = useState();
    const labelKey = Object.keys(value).sort();
    const [mode, setMode] = useState(true);
    const [error, setError] = useState(false);
    const [identifierSaved, setIdentifierSaved] = useState(false)
    const [originalIdentifierData] = useState(props.oldValue)
    const [disableSaveButton, setDisableSaveButton] = useState(true)

    useEffect(() => {
        setLabel(props.label);
        setValue(props.value);
        setError(props.error);
        //setUpdatedValue(props.value)
    }, [props.label, props.value, props.error]);

    /**
     * Hadle click on + icon
     */
    const handleClick = () => {
        setOpen(!open);
    };

    /**
     * Handel Edit mode Change
     */
    const changeMode = () => {
        if(mode && open){
            setMode(false)
            if(value && !value['Status']){
                setValue({...value, ['Status']:[{value:''}]})
              //  setUpdatedValue({...value, ['Status']:[{value:''}]})
            }
        }else if(mode && !open){
            setMode(false)
            setOpen(true)
            if(value && !value['Status']){
                setValue({...value, ['Status']:[{value:''}]})
                //setUpdatedValue({...value, ['Status']:[{value:''}]})
            }
        }else{        
            setMode(true)
            props.deletePreviousChange(props.index)
            setIdentifierSaved(false)
            setValue(props.value)
            setUpdatedValue(props.value)
            setDisableSaveButton(true)
        }   
    }

    const undoSavedChanges = () =>{
        props.deletePreviousChange(props.index)
        setIdentifierSaved(false)
        setValue(props.value)
        setUpdatedValue(props.value)
        setDisableSaveButton(true)
    }

    /**
     * check all addres Attribute
     * @param {*} keys 
     * @param {*} arrayValue 
     * @returns final flag for adderess
     */
    const checkAllAddressAttribute = (keys, arrayValue) => {
        let flag = false;
        if (keys.length === 0) {
            return flag;
        } else {
            keys.forEach((key) => {
                flag = flag || arrayValue[key]
            })
            return flag;
        }
    }

    const deleteItemFromList = () => {
        props.deleteItemFromList(value)
    }
    /**
     * Update DCR values
     * @param {*} Value 
     * @param {*} Name 
     * @param {*} flag 
     * @param {*} arrayFlag 
     */
    const updateValue = (Value, Name, flag, arrayFlag) => {
        let AddressChange = CONSTANT.ADDRESS_ATTRIBUTE.includes(Name);
        if (AddressChange) {
            let flagsObject = {
                ...updatedValueFlag,
                [Name]: flag
            }
            setUpdatedValueFlag({
                ...updatedValueFlag,
                [Name]: flag
            })
            props.updateValue({
                ...updatedValue,
                [Name]: arrayFlag ? [Value] : Value
            },
                checkAllAddressAttribute(flagsObject ? Object.keys(flagsObject) : [], flagsObject)
            )

        } else {
            props.updateValue({
                ...updatedValue,
                [Name]: arrayFlag ? [Value] : Value
            }, flag,props.index)
            setDisableSaveButton(false)
        }

        setUpdatedValue({
            ...updatedValue,
            [Name]: arrayFlag ? [Value] : Value
        })
        
    }

    const saveIdentifier = () =>{ 
        if(value && value['Status'] && value['Status'][0]['value'] == ''){
            props.noDataInIdentitifer('Please select Identifier Status fields before Submitting Request !')            
        }
        else if(value && value['Status'] && originalIdentifierData && originalIdentifierData['Status'] && value['Status'][0]['value'] == originalIdentifierData['Status'][0]['value']){
            props.noDataInIdentitifer(`Please select different Identifier Status before Submitting Request. You cannot save same status !`)
        }
        else{
            props.saveUpdatedIdentifier(props.index)
            setMode(true)
            setIdentifierSaved(true)
        }     
       
    }

    // not allow lilly identiers to edited on Open Data profiles
    const disableEditIdentifer = ()=>{
        if(IdentifierList.OPEN_DATA_SOURCES.includes(props?.profileSource[0]?.value)){
            if(IdentifierList.OPEN_DATA_SOURCES.includes(value.Source[0].value)){
                return true;
            }
            else{
                return false;
            }
        }
        return true;
    }

    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
            sx={{border:(props.newAddedValue ? '1.5px solid blue' : (identifierSaved ? '1.5px solid green' : !mode ? '1.5px solid orange' : '1.5px solid lightgrey') ), margin:'10px 0', padding: '0px', borderRadius:'4px'}}
        >
            <ListItem sx={{padding: '5px'}}>
                {
                    props.newAddedValue === true &&(
                        <Tooltip disableFocusListener title={<span className='_wg-dynamic-text'>Remove Identifier</span>}>
                            <IconButton size='small' onClick={deleteItemFromList}>
                                <CloseIcon fontSize='1.0rem'/>
                            </IconButton>
                        </Tooltip>
                    ) 
                }
                <ListItemText sx={{marginLeft:'5px'}}  primary={label} />
                {
                    props.mode === "Edit" &&
                    props.profileSource != undefined &&
                        mode &&
                        !identifierSaved &&
                        !props.newAddedValue &&
                        value.Type && value.Source != undefined &&
                        !nonEditableIdnetifier.NON_EDITABLE_IDENTIFIER_LIST.includes(value.Type[0]['value']) &&
                        nonEditableIdnetifier.EDITABLE_IDENTIFIER_SOURCE.includes(value.Source[0]['value']) &&
                        disableEditIdentifer()
                        &&
                        (
                        <>
                            {props.profileSource &&
                            props.profileSource[0].value == "VNDR-CGDM"  ?  (
                           (!nonEditableIdnetifier.EDITABLE_IDENTIFIER_SOURCE.includes(value?.Source[0]['value']))
                            ? '' :<Tooltip disableFocusListener title="Edit" id="tooltip">
                            <CreateIcon className="pointer text-primary" onClick={changeMode} />
                             </Tooltip> 
                            
                        ) : <Tooltip disableFocusListener title="Edit" id="tooltip">
                        <CreateIcon className="pointer text-primary" onClick={changeMode} />
                         </Tooltip>  }
                        </>
                        )
                    }
                    {props.mode === 'Edit' && !mode && !identifierSaved && !props.newAddedValue &&
                    value.Type &&
                    !nonEditableIdnetifier.NON_EDITABLE_IDENTIFIER_LIST.includes(value.Type[0].value)
                    &&
                    nonEditableIdnetifier.EDITABLE_IDENTIFIER_SOURCE.includes(value.Source[0].value)
                    && disableEditIdentifer() && (
                    <Tooltip disableFocusListener title="Cancel Edit" id="tooltip">
                    <EditOffIcon className="pointer text-primary" onClick={changeMode} />
                    </Tooltip>
                    )} 
                    {props.mode === 'Edit' && identifierSaved && !props.newAddedValue &&
                    value.Type &&
                    !nonEditableIdnetifier.NON_EDITABLE_IDENTIFIER_LIST.includes(value.Type[0].value)
                    &&
                    nonEditableIdnetifier.EDITABLE_IDENTIFIER_SOURCE.includes(value.Source[0].value)&&
                    (
                    <Tooltip disableFocusListener title="Undo Saved Info" id="tooltip">
                    <ReplayIcon className="pointer text-primary" onClick={undoSavedChanges} />
                    </Tooltip>
                    )}

                {open ? (
                    <Tooltip disableFocusListener title={<span className='_wg-dynamic-text'>Expand less</span>}>
                        <IconButton size='small' onClick={handleClick}>
                            <ExpandLess 
                                sx={{color: 'rgba(0, 0, 0, 0.54)'}} 
                                className='pointer' 
                            />
                        </IconButton>
                    </Tooltip>
                ) 
                : (
                    <Tooltip disableFocusListener title={<span className='_wg-dynamic-text'>Expand more</span>}>
                        <IconButton size='small' onClick={handleClick}>
                            <ExpandMore 
                                sx={{color: 'rgba(0, 0, 0, 0.54)'}} 
                                className='pointer' 
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </ListItem>
            <Collapse in={open}  timeout="auto" unmountOnExit>
                <List component="div" className="bg-grey" >
                    <ListItem className={classes.nested}>
                        <ListItemText primary={
                            labelKey?.map((labels, i) => {
                                let passLabel = labels;
                                let propertyValue = value[labels];
                                if (labels.length > 3) {
                                    labels = labels.replace(/([A-Z])/g, ' $1')
                                        .replace(/^./, (str) => str.toUpperCase())
                                }
                                labels = filter.getLabelName(labels !== undefined ? labels.trim() : labels);

                                if (props.sources !== undefined) {
                                    return (
                                        <div key={i}>
                                            <span className="text-muted mb-2  mt-2">{labels + ':TTTT' || ''}</span>
                                            <span className=" mb-0  mt-2">{propertyValue || 'TTTTTT'}</span>

                                        </div>
                                    )
                                }
                                let subObjectFlag = propertyValue[0] !== undefined && (Object.keys(propertyValue[0]).includes('value'));
                                if (label.toLocaleLowerCase() !== 'ov' && subObjectFlag) {

                                    return (
                                        <SingleValue
                                            existingAddessFlagState={true}
                                            oldEffectiveEndDate={props?.oldEffectiveEndDate}
                                            entity={props.entity}
                                            mode={!mode && props.mode === 'Edit' && CONSTANT.HCP_IDENTIFIER_DEACTIVATION_EDIT_FIELD.includes(labels)  ? 'Edit' : undefined}
                                            requiredAddress={(props.source != 'VNDR-CGDM' ? CONSTANT.HCO_ADDRESS_EDITABLE_EPH.includes(labels) : CONSTANT.HCO_ADDRESS_EDITABLE_VENDOR.includes(labels))}
                                            key={i}
                                            label={labels}
                                            value={propertyValue}
                                            error={error}
                                            updatedValue={(value, flag) => updateValue(value, passLabel, flag, true)}
                                        />);
                                }
                                return '';
                            })

                        } />
                    </ListItem>
                    {!mode && 
                        <Stack spacing={1} alignItems='flex-end' direction='row' justifyContent='flex-end'>
                            <Button
                                sx={{color:'gray', "&:hover":{background:"rgba(134,136,138,0.05)"}}}
                                size='small' 
                                className='_wg-dynamic-text'
                                onClick={changeMode}
                                >
                                Cancel
                            </Button>
                            <Button 
                                sx={{color:'var(--lilly-primary)', transition:'100ms background linear',
                                    "&:hover": {backgroundColor: 'rgba(219, 28, 28,0.05)'}, }} 
                                size='small'
                                className='_wg-dynamic-text' 
                                disabled = {disableSaveButton}
                                onClick={saveIdentifier}                                   
                                >
                                Save
                            </Button>
                        </Stack>
                    }
                </List>
            </Collapse>
        </List>
    );
}
export default ListView;